export default "/shopify.06e7bfab-a59cd2.png";